var render, staticRenderFns
import script from "./TextareaSkeleton.vue?vue&type=script&lang=ts&"
export * from "./TextareaSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./TextareaSkeleton.vue?vue&type=style&index=0&id=567983a1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports